<template lang="pug">
.content-wrap
	.content-top
		.con
			.resbox.res-statement
				.resbox-con
					.resbox-tabs.text-white
						template(v-if="!this.showPlatformWinLose")
							.member-setting
								.member-setting-title
									.member-setting-icon.icon-statement
										img(src='/new/img/icon-statement.svg')
									.member-setting-text(v-if="!showReport") {{$t('ui.statement')}}
									.member-setting-text(v-else)
										span.pointer(@click="clearReportType") {{$t('ui.statement')}} 
										span > 
										span.pointer {{reportType}}
							ul.nav.nav-tabs.nav-member
								li.nav-item.w-100.pointer(@click="changeTab(0)")
									.nav-link(:class="{'active' : selectedTab === 0}" data-bs-toggle='pill' data-bs-target='#daily-statement') {{$t('ui.statement_daily')}} 
								li.nav-item.w-100.pointer(@click="changeTab(1); reset()")
									.nav-link(:class="{'active' : selectedTab === 1}" data-bs-toggle='pill' data-bs-target='#transaction-history') {{ $t('ui.transaction_history') }}
							.tab-content
								dailyStatement(v-if="selectedTab===0" @showBetHistory="showBetHistory" @reportSelected="reportSelected" ref="dailyStatement")
								transHistory(v-if="selectedTab===1" @updateTrans="updateTrans")
						template(v-else)
							.member-setting
								.member-setting-title
									.member-setting-icon.icon-statement
										img(src='/new/img/icon-statement.svg')
									.member-setting-text
										span.pointer(@click="backToStatement") {{$t('ui.statement')}} 
										span > 
										span.pointer(@click="clearCategory") {{$t('ui.bet_history')}} 
										span {{category}}
								platformWinLose(ref="platformWinLose" :platformData="platformData" @platformSelected="platformSelected")
</template>
<script>
import dailyStatement from '@/component/statement/_dailyStatement.vue'
import transHistory from '@/component/statement/_transHistory.vue'
import platformWinLose from '@/component/statement/_platformWinLose.vue'
import _ from "lodash";
export default {
	components:{
		dailyStatement,
		transHistory,
		platformWinLose,
	},
	data(){
		return{
			selectedTab: 0,
			transNo: 0,
			showPlatformWinLose: false,
			showReport: false,
			platformData: [],
			category: ""
		}		
	},
	computed: {
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
	watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    }
  },
	mounted(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/statement`);
		window.scroll(0,0)
		var q = this.$route.query;
		if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.checkTrans == true){
				this.selectedTab = 1
			}
    }
	},
	methods:{
		changeTab(option){
			if(option === this.selectedTab){
				return;
			}else{
				this.selectedTab = option
			}
		},
		updateTrans(e){
			this.transNo = e
		},
		showBetHistory(e){
			this.showPlatformWinLose = true
			this.platformData = e.data
		},
		reportSelected(e){
			this.showReport = true
			switch(e){
				case 0:
					this.reportType = this.$t('ui.transfer')
					break;
				case 1:
					this.reportType = this.$t('ui.bonus_details')
					break;
				case 2:
					this.reportType = this.$t('ui.adjustment_details')
					break;
				case 3:
					this.reportType = this.$t('ui.referee')
				default:
					break;
			}
		},
		platformSelected(e){
			this.category = "> " + this.$t('ui.'+ e.toLowerCase())
		},
		clearReportType(){
			if(this.showReport === false && this.reportType === ""){
				return
			}else{
				this.showReport = false
				this.reportType = ""
				this.$refs.dailyStatement.reset()
			}
		},
		backToStatement(){
			if(this.showPlatformWinLose === false && this.category === ""){
				return
			}else{
				this.showPlatformWinLose = false
				this.category = ""
			}
		},
		clearCategory(){
			this.$refs.platformWinLose.reset()
			this.category = ""
		},
		reset(){
			this.category = ""
			this.reportType = ""
			this.showReport = false
			this.platformWinLose = false
		}
	}
}
</script>